import axios from "axios";

const API_URL = "https://hmc.co.il/wp-json/quatro/v1/app";

export async function getUserDetails(license) {
  try {
    const { status, data } = await axios.get(
      `${API_URL}/profile?license=${license}`
    );
    if (status === 200 && data["status"] === "success") return data["data"];
  } catch (err) {
    throw err;
  }
}

export async function requestUpdateUserDetails(license, body) {
  try {
    const { status, data } = await axios.put(
      `${API_URL}/profile?license=${license}`,
      body
    );
    if (status === 200) return data;
  } catch (err) {
    throw err;
  }
}

export async function sendLicensePlateForm(
  name,
  user_id,
  oldNumber,
  newNumber
) {
  // try {
  //   const { status, data } = await axios
  //     .post
  //     // `${API_URL}/profile?license=${newNumber}`
  //     ();
  //   // if (status === 200 && data["status"] === "success") {};
  // } catch (err) {
  //   throw err;
  // }
}
